import Axios from 'axios'
import handler from '@/config/network/handler'
import utils from '@/_fdp/utils'
import normalize from 'normalize-path'
import { isEmpty } from 'lodash'
/*
  Axios 객체 생성 관리 (2018/05/10 정재윤)
    - Http Header 기본 설정 관리
    - Intercepter request/response 핸들러 관리

  Todo
    - debounce 처리 방안 고민 debounce promise 적용?
*/

function AxiosWrapper (httpConfig) {
  this.httpConfig = httpConfig || window.vue.config.http
  // this.axios = Axios.create(this.httpConfig)
  // 쿠키값을 request에 포함시킴
  this.axios = Axios.create({...this.httpConfig, withCredentials: true})

  this.getCookie = (cookieName) => {
    var cookieValue = null
    if (document.cookie) {
      var array = document.cookie.split((escape(cookieName) + '='))
      if (array.length >= 2) {
        var arraySub = array[1].split(';')
        cookieValue = unescape(arraySub[0])
      }
    }
    return cookieValue
  }

  // http header 용
  // - token 값 설정
  // - proxy 설정
  // - timeout 설정
  this.makeHeader = (context, userHeader) => {
    // let isNrwMobile = window.vue.getStore('mmpAuth').getters.isNrwMobile
    let isNrwMobile = false
    if (window.location.hostname.startsWith('m.') || window.location.hostname.startsWith('mstg.')) { // NRW : m.multi...
      isNrwMobile = true
      let mmpAuthStore = window.vue.getStore('mmpAuth')
      mmpAuthStore.commit('SET_NRW_INFO', isNrwMobile)
    }
    // token 정보 설정
    let tokenAuthObj = window.vue.getStore('mmpAuth').getters.getToken
    let tokenAuth = tokenAuthObj ? tokenAuthObj.tokenAuth : ''
    let isAutoLogin = window.vue.getStore('mmpAuth').getters.isAutoLogin

    if (isNrwMobile) {
      // console.log('http.js >> authenticated', this.getCookie('_nrw_lg'))
      let authenticated = this.getCookie('_nrw_lg') === 'true'
      if (!authenticated) {
        if (!isAutoLogin) {
          tokenAuth = ''
          window.vue.getStore('mmpAuth').commit('CLEAR_TOKEN_INFO') // 로컬스토리지 토큰삭제
        }
      }
    }

    // 다국어-날짜포맷코드,타임존코드 설정
    const locale = localStorage.getItem('language') || 'ko'
    const dateFormat = localStorage.getItem('dateFormat') || 'ko'
    const timeZone = localStorage.getItem('timeZone') || 'Asia/Seoul'

    let customHeader = {
      'Accept-Language': `${locale}-${dateFormat},${timeZone}`,
      'Access-Token': tokenAuth
    }

    if (tokenAuth) {
      customHeader.Authorization = 'Bearer ' + tokenAuth
    }

    let axiosHeaderConfig = {
      headers: customHeader,
      timeout: this.httpConfig.timeout,
      proxy: this.httpConfig.proxy
    }

    if (userHeader === undefined) {
    } else {
      axiosHeaderConfig.headers = Object.assign(axiosHeaderConfig.headers, userHeader)
    }

    return axiosHeaderConfig
  }

  // http get 처리용
  this.makeParam = (context, data) => {
    var store = window.vue.getStore('root')

    let tran = {
      'tranId': '',
      'reqId': '',
      'reqTime': '',
      'rspTime': ''
    }

    tran.tranId = utils.generateUID()
    tran.reqId = store.getters.getSession.userId
    tran.reqTime = new Date().getTime() // millisecond of epoch

    // merge
    let param = {
      params: Object.assign(handler.userParam(context, data), tran)
    }

    return param
  }

  // http post 처리용
  this.makeBody = (context, data) => {
    var store = window.vue.getStore('root')

    let jsonBody = {
      'tran': {
        'tranId': '',
        'reqId': '',
        'reqTime': '',
        'rspTime': ''
      }
    }

    jsonBody.tran.tranId = utils.generateUID()
    jsonBody.tran.reqId = store.getters.getSession.userId
    jsonBody.tran.reqTime = new Date().getTime() // millisecond of epoch

    data = Object.assign(handler.userBody(context, data), jsonBody)

    return data
  }

  this.setCommonHeader = (axios) => {
  // Http Header 기본 설정
    axios.defaults.headers.common['Content-Type'] = 'application/json'
    axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
  }

  this.setInterceptor = (axios) => {
  // request intercepter 설정
  // - 리턴값에 대해 status 값 전달하여, 오류 처리
    axios.interceptors.request.use((request) => {
      request = handler.userRequestIntercepter(request)

      return request
    }, error => {
      error = handler.userErrorIntercepter(error)
      console.error(error.request.status)
      return error
    })

    // response intercepter 설정
    // - 리턴값에 대해 status 값 전달하여, 오류 처리
    axios.interceptors.response.use((response) => {
      if (response.data.tran !== undefined) {
        response.data.tran.rspTime = new Date().getTime() // millisecond of epoch
      }

      response = handler.userResponseIntercepter(response)

      return Promise.resolve(response)
    }, error => {
      error = handler.userErrorIntercepter(error)
      console.error(error)
      return Promise.reject(error)
    })
  }

  /*
  Parameters
  - url : http url
  - param : http params
  */
  this.loadRes = (url) => {
    let params = { params: {} }
    let baseUrl = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))
    let requestUri = baseUrl + normalize('/' + url)
    let axios = this.axios

    if (axios === undefined) {
      console.error('Instance null')
      return Promise.reject(new Error('Instance Null'))
    }

    try {
      let headers = this.makeHeader(undefined)

      // get 요청의 경우 header/param을 동일 오브젝트 속성으로 포함하여 전달
      let reqParams = Object.assign(params, headers)

      return axios.get(requestUri, reqParams)
        .then(function (response) {
          return Promise.resolve(response.data)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  /*
  Parameters
  - context : Vue instance
  - url : http url
  - param : http params
  */
  this.get = (context, urlObj, param, header) => {
    var url = urlObj.url
    var requestUri = this.httpConfig.baseURI + normalize('/' + url)
    var axios = this.axios

    if (axios === undefined) {
      console.error( 'Instance null')
      return Promise.reject(new Error('Instance Null'))
    }

    try {
      let params = this.makeParam(context, param)
      let headers = this.makeHeader(context, header)

      var showSpinner = (typeof urlObj.showSpinner === 'boolean') ? urlObj.showSpinner : true
      let data = Object.assign(params, headers, { showSpinner: showSpinner })

      return axios.get(requestUri, data)
        .then(function (response) {
          return Promise.resolve(response)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  /*
  Parameters
  - context : Vue instance
  - url : http url
  - param : http params
  */
  this.post = (context, urlObj, body, header) => {
    var url = urlObj.url
    var requestUri = this.httpConfig.baseURI + normalize('/' + url)
    var axios = this.axios
    if (axios === undefined) {
      console.error( 'Instance null')
      return Promise.reject(new Error('Instance Null'))
    }

    try {
      let jsonData = this.makeBody(context, body)
      let headers = this.makeHeader(context, header)

      var showSpinner = (typeof urlObj.showSpinner === 'boolean') ? urlObj.showSpinner : true
      // console.log('post showSpinner', showSpinner)
      let newHeaders = Object.assign(headers, { showSpinner: showSpinner })
      return axios.post(requestUri, jsonData, newHeaders)
        .then(function (response) {
          return Promise.resolve(response)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  /*
  Parameters
  - context : Vue instance
  - url : http url
  - param : http params
  */
  this.upload = (context, urlObj, body, header) => {
    var url = urlObj.url
    var requestUri = this.httpConfig.baseURI + normalize('/' + url)
    var axios = this.axios

    if (axios === undefined) {
      console.error( 'Instance null')
      return Promise.reject(new Error('Instance Null'))
    }
    // header = Object.assign(header, { showSpinner: urlObj.showSpinner ? urlObj.showSpinner : true })
    try {
      let headers = this.makeHeader(context, header)

      let _boundary = '__MulTiCamPUs__'
      headers.headers['Content-Type'] = `multipart/form-data; boundary=${_boundary}`

      // console.log(' headers >>', headers)
      return axios.post(requestUri, body, headers)
        .then(function (response) {
          return Promise.resolve(response)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  /*
  Parameters
  - context : Vue instance
  - url : http url
  - param : http params
  */
  this.delete = (context, urlObj, body, header) => {
    var url = urlObj.url
    var requestUri = this.httpConfig.baseURI + normalize('/' + url)
    var axios = this.axios

    if (axios === undefined) {
      console.error('Instance null')
      return Promise.reject(new Error('Instance Null'))
    }
    // header = Object.assign(header, { showSpinner: urlObj.showSpinner ? urlObj.showSpinner : true })
    try {
    // axios 의 delete의 경우 url 과 config 인자 두개만 허용 하기에, 데이터를 넘길 때 {data : {} } 형태로 전송해야 함
      let data = {
        data: this.makeBody(context, body)
      }
      let headers = this.makeHeader(context, header)
      let config = Object.assign(data, headers)

      return axios.delete(requestUri, config)
        .then(function (response) {
          return Promise.resolve(response)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }

  /*
  Parameters
  - context : Vue instance
  - url : http url
  - param : http params
*/
  this.put = (context, urlObj, body, header) => {
    var url = urlObj.url
    var requestUri = this.httpConfig.baseURI + normalize('/' + url)
    var axios = this.axios

    if (axios === undefined) {
      console.error('Instance null')
      return Promise.reject(new Error('Instance Null'))
    }
    // header = Object.assign(header, { showSpinner: urlObj.showSpinner ? urlObj.showSpinner : true })
    try {
      let jsonData = this.makeBody(context, body)
      let headers = this.makeHeader(context, header)

      return axios.put(requestUri, jsonData, headers)
        .then(function (response) {
          return Promise.resolve(response)
        })
        .catch(function (error) {
          console.error(error)
          return Promise.reject(error)
        })
    } catch (error) {
      console.error(error)
      return Promise.reject(error)
    }
  }
}

export default AxiosWrapper



// WEBPACK FOOTER //
// ./src/_fdp/core/network/http.js